export const SAVE_RELATIONSHIP_NAME = 'SAVE_RELATIONSHIP_NAME';
export const RESET_RELATIONSHIP_NAME = 'RESET_RELATIONSHIP_NAME';
export const INITIATE_QUESTIONNAIRE_DYNAMIC_LANDING_SUCCESS =
    'INITIATE_QUESTIONNAIRE_DYNAMIC_LANDING_SUCCESS';
export const INITIATE_QUESTIONNAIRE_DYNAMIC_LANDING_FAILURE =
    'INITIATE_QUESTIONNAIRE_DYNAMIC_LANDING_FAILURE';
export const INITIATE_QUESTIONNAIRE_DYNAMIC_LANDING =
    'INITIATE_QUESTIONNAIRE_DYNAMIC_LANDING';
export const START_QUESTIONNAIRE_DYNAMIC_LANDING =
    'START_QUESTIONNAIRE_DYNAMIC_LANDING';
export const SEND_BPS_QUESTION = 'SEND_BPS_QUESTION';
export const SEND_BPS_QUESTION_SUCCESS = 'SEND_BPS_QUESTION_SUCCESS';
export const SEND_BPS_QUESTION_FAILURE = 'SEND_BPS_QUESTION_FAILURE';
export const RESET_SESSIONID = 'RESET_SESSIONID';
export const RELATIONSHIP_NAMEFIELD_ERROR =
    'RELATIONSHIP_NAMEFIELD_ERROR';
export const UPDATE_PAGE_FORM_FIELD = 'UPDATE_PAGE_FORM_FIELD';
export const INITIATE_QUESTIONNAIRE_BUSINESSTYPE =
    'INITIATE_QUESTIONNAIRE_BUSINESSTYPE';
export const UPDATE_TO_PREVIOUS_PAGE = 'UPDATE_TO_PREVIOUS_PAGE';
export const UPDATE_APP_PAGE_ANSWERS = 'UPDATE_APP_PAGE_ANSWERS';
export const PAGE_ACTION_NEXT = 'PAGE_ACTION_NEXT';
export const PAGE_ACTION_BACK = 'PAGE_ACTION_BACK';
export const SET_BACK_BUTTON_FLAG = 'SET_BACK_BUTTON_FLAG';
export const RESET_BANKER_QUESTIONNAIRE =
    'RESET_BANKER_QUESTIONNAIRE';
export const REVIEW_BANKER_QUESTIONNAIRE =
    'REVIEW_BANKER_QUESTIONNAIRE';
export const NAVIGATE_TO_FIRST_QUESTION =
    'NAVIGATE_TO_FIRST_QUESTION';
export const RESET_NAVIGATE_TO_FIRST_QUESTION =
    'RESET_NAVIGATE_TO_FIRST_QUESTION';
